module.exports = __webpack_public_path__ + "img/log.d731c38e.svg";